import { render, staticRenderFns } from "./PageSetBanner.vue?vue&type=template&id=7ccd47c9&scoped=true&"
import script from "./PageSetBanner.vue?vue&type=script&lang=js&"
export * from "./PageSetBanner.vue?vue&type=script&lang=js&"
import style0 from "./PageSetBanner.vue?vue&type=style&index=0&id=7ccd47c9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccd47c9",
  null
  
)

export default component.exports